import { useFormik } from "formik";
import React from "react";
import InputField from "./InputField";
import { useDispatch, useSelector } from "react-redux";
import { addContact } from "../store/contact/actions/actionsCreators";
import { contactSchema } from "../Schema/Schema";

const ContactArea = () => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.contact);
  const initialValues = {
    name: "",
    email: "",
    phoneNumber: "",
    option: "",
    message: "",
  };
  const { handleSubmit, values, handleChange, resetForm, errors, touched } =
    useFormik({
      initialValues,
      validationSchema: contactSchema,
      onSubmit: (values) => {
        dispatch(addContact(values, resetForm));
      },
    });

  return (
    <>
      <div className="contact-area space">
        <div className="container">
          <div className="row gy-4 justify-content-center">
            <div className="col-xxl-3 col-lg-4 col-md-6">
              <div className="contact-info">
                <div className="contact-info_icon">
                  <i className="fas fa-map-marker-alt" />
                </div>
                <h6 className="contact-info_title">Address</h6>
                <p className="contact-info_text">POOL ROAD INDUSTRIAL ESTATE</p>
                <p className="contact-info_text">
                  NUNEATON, CV10 9AE, United Kingdom
                </p>
              </div>
            </div>
            <div className="col-xxl-3 col-lg-4 col-md-6">
              <div className="contact-info">
                <div className="contact-info_icon">
                  <i className="fas fa-phone-alt" />
                </div>
                <h6 className="contact-info_title">Phone Number</h6>
                <p className="contact-info_text mb-4">
                  <a href="tel:07888261685">07496360002</a>
                  <br />
                  <a href="tel:02476347151">02476347151</a>
                </p>
              </div>
            </div>
            <div className="col-xxl-3 col-lg-4 col-md-6">
              <div className="contact-info">
                <div className="contact-info_icon">
                  <i className="fas fa-envelope" />
                </div>
                <h6 className="contact-info_title">E-mail</h6>
                <p className="contact-info_text mb-4">
                  <a href="mailto:inquiry@silverlineautoltd.co.uk">
                    inquiry@silverlineautoltd.co.uk
                  </a>
                </p>
              </div>
            </div>
            <div className="col-xxl-3 col-lg-4 col-md-6">
              <div className="contact-info">
                <div className="contact-info_icon">
                  <i className="fas fa-clock" />
                </div>
                <h6 className="contact-info_title">Opening</h6>
                <p className="contact-info_text"> Mon-09:00 – 17:00</p>
                <p className="contact-info_text"> Tue-09:00 – 17:00</p>
                <p className="contact-info_text"> Wed-09:00 – 17:00</p>
                <p className="contact-info_text"> Thu-09:00 – 17:00</p>
                <p className="contact-info_text"> Fri-09:00 – 17:00</p>
                <p className="contact-info_text"> Sat-09:00 – 17:00</p>
                <p className="contact-info_text"> Sun-09:00 – 17:00</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="space-bottom">
        <div className="container">
          <div className="map-sec">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2244.0292946337518!2d-1.491334973549135!3d52.527203372063035!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4877520661cfe13f%3A0xffb9917520d92961!2sNuneaton%20CV10%209AE%2C%20UK!5e1!3m2!1sen!2s!4v1743949304702!5m2!1sen!2s"
              width="600"
              height="450"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
              title="Google Maps Location"
            />
          </div>
        </div>
      </div>
      <div className="space-bottom">
        <div className="container">
          <div className="row flex-row-reverse">
            <div className="col-lg-6 text-lg-end">
              <div className="faq-thumb2 mb-xl-0 mb-50">
                <div className="about-counter-grid jump">
                  <img
                    src="assets/img/icon/faq2-counter-icon-1.svg"
                    alt="Fixturbo"
                  />
                  <div className="media-right">
                    <h3 className="about-counter">
                      <span className="counter-number">250</span>+
                    </h3>
                    <h4 className="about-counter-text">Services we provide</h4>
                  </div>
                </div>
                <img src="assets/img/normal/form-image.jpg" alt="SilverLine" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="contact-form-wrap p-0">
                <div className="title-area">
                  <span className="sub-title">Contact form</span>
                  <h2 className="sec-title">Car Repair The Best Services</h2>
                </div>
                <form
                  onSubmit={handleSubmit}
                  className="appointment-form ajax-contact"
                >
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <InputField
                          onChange={handleChange}
                          type="text"
                          value={values.name}
                          className="form-control"
                          name="name"
                          id="name"
                          placeholder="Your Name"
                          error={errors.name}
                          touched={touched.name}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <InputField
                          type="email"
                          onChange={handleChange}
                          className="form-control"
                          value={values.email}
                          name="email"
                          id="email"
                          placeholder="Email Address"
                          error={errors.email}
                          touched={touched.email}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <InputField
                          type="text"
                          onChange={handleChange}
                          value={values.phoneNumber}
                          className="form-control"
                          name="phoneNumber"
                          id="number"
                          placeholder="Phone Number"
                          error={errors.phoneNumber}
                          touched={touched.phoneNumber}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <select
                          name="option"
                          onChange={handleChange}
                          value={values.option}
                          className="form-select"
                          defaultValue={"Choose"}
                          error={errors.option}
                          touched={touched.option}
                        >
                          <option value="Choose">Choose a Option</option>
                          <option value="Construction">Auto Repair</option>
                          <option value="Real Estate">Car Repair</option>
                          <option value="Industry">Automotive</option>
                        </select>
                        {errors.option ? (
                          <p className="text-danger">{errors.option}</p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="form-group col-12">
                    <textarea
                      placeholder="Message here.."
                      className="form-control"
                      onChange={handleChange}
                      value={values.message}
                      name="message"
                      defaultValue={""}
                    />
                    {errors.option ? (
                      <p className="text-danger">{errors.option}</p>
                    ) : null}
                  </div>
                  <div className="form-btn col-12">
                    <button className="btn style2" type="submit">
                      {isLoading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Loading...
                        </>
                      ) : (
                        <>
                          Submit <i className="fas fa-arrow-right ms-2" />
                        </>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactArea;
